import type { components } from "./schema";
import axiosInstance from "./axiosInstance";

type BlogPostSchema = components["schemas"]["BlogPost"];

export type BlogPost = BlogPostSchema & {
  is_vertical_video?: boolean | null;
};

export async function getBlogPosts() {
  const { data } = await axiosInstance.get<BlogPost[]>("/blog-post");
  return Array.isArray(data) ? data : [];
}

export async function getBlogPost(id: number) {
  const { data } = await axiosInstance.get<BlogPost>(`/blog-post/${id}`);
  return data;
}
